export const RANGE = 'RANGE_';

export function erreurRange(message, champs, messages, preMessage) {
  const valeurs = message.slice(RANGE.length, message.indexOf('|'));
  let min = 0;
  let max = null;
  let nouveauMessage = '';
  if (valeurs.indexOf('_') !== -1) {
    min = valeurs.split('_')[0];
    max = valeurs.split('_')[1];
    if (max !== null) {
      nouveauMessage = 'validation.range.default';
    } else if (min === '0') {
      nouveauMessage = 'validation.range.positif';
    } else if (min === '0.01') {
      nouveauMessage = 'validation.range.positifObligatoire';
    }
  } else {
    nouveauMessage = 'validation.range.default';
  }
  if (messages.some(m => {
    return m.parametres && m.parametres.name === champs;
  })) return;
  messages.push({
    message: nouveauMessage,
    parametres: { name: champs, min: min, max: max },
    preMessage: preMessage,
  });
}
